import { useConfirm } from 'vuetify-use-dialog'
import type { ConfirmDialogOptions } from 'vuetify-use-dialog/utils'

/**
 * Abstraction for the vuetify-use-dialog [useConfirm](https://github.com/wobsoriano/vuetify-use-dialog) composable to make it easier to use with German translations.
 * @returns callback to open the confirmation dialog. After the dialog is closed,
 * the promise resolves to true if the user confirmed the action, otherwise false.
 */
export const useConfirmationDialog = () => {
  const confirm = useConfirm()
  const confirmCallback = async (
    options: ConfirmDialogOptions
  ): Promise<boolean> => {
    return await confirm({
      title: '',
      confirmationText: 'OK',
      cancellationText: 'Abbrechen',
      dialogProps: {
        width: 700,
        ...options.dialogProps,
      },
      ...options,
    })
  }
  return confirmCallback
}
